/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import { IconButton, IconButtonProps } from "@mui/material";

/**
 * プロパティ定義
 */
type Props = IconButtonProps & {
  /** アイコン画像要素 */
  children: React.ReactNode;
  /** 押下時イベント */
  onClick?: () => void;
};

/**
 * アイコン画像だけのボタン
 * @param props コンポーネントのProps
 */
export default function AppIconButton(props: Props) {
  /**
   * ボタン押下時処理
   */
  const handleClick = () => {
    if (props.onClick) props.onClick();
  };

  return <IconButton {...props} onClick={handleClick} />;
}
